import React, { useEffect, useState, useContext } from 'react';
import Swal from 'sweetalert2';
import ApiAnuidades from '../services/anuidadeService';
import ApiAcademia from '../services/academiaService';
import { Context } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import FormatDataIsoToBr from '../components/FormatDataIsoToBr';
import ValorMonetario from '../components/ValorMonetario';
import FormaPagamento from '../components/FormaPagamento';

export default function AlunoFormulario() {
    const navigate = useNavigate();
    const { handleLogout } = useContext(Context);  
    const user = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('token');
    const [anuidade, setAnuidade] = useState(null);
    const [pedido, setPedido] = useState(null);
    const [academia, setAcademia] = useState([]);
    const [pagamento, setPagamento] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const [intervalStarted, setIntervalStarted] = useState(false);
    const ano = new Date().getFullYear();    

    const handlepagamento = async (userId, anuidadeId) => {
        if (isProcessing) return;
        setIsProcessing(true);
        
        const data = { userId, anuidadeId };
        try {
            const response = await ApiAnuidades.pagamento(data, token);
            if (response.statusRetorno === 401){
                handleLogout();
                navigate('/');
            }
            if (response.status === 'error') {
                Swal.fire({
                    title: 'Houve um erro ao consultar a sua anuidade!',
                    text: response.message,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            } else {
                console.log(response,1)
                setPedido(response.pedido);
                setPagamento(false);
            }
        } catch (error) {
            Swal.fire({
                title: 'Erro ao processar o pagamento!',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        } finally {
            setIsProcessing(false);
        }
    };

    const listarMinhaAcademia = async () => {
        try {
            const response = await ApiAcademia.listarPorUserId(user.id, token);
            if (response.statusRetorno === 401){
                handleLogout();
                navigate('/');
            }
            if (response) {
                console.log(response,2);
                setAcademia(response);
            } else {
                Swal.fire({
                    title: 'Houve um erro ao consultar seu vínculo com uma academia',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Houve um erro ao consultar seu vínculo com uma academia!',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
            handleLogout();
            navigate('/');
        }
    }; 

    const listarAnuidadeVigente = async () => {
        try {
            const response = await ApiAnuidades.listarAnuidadeAluno(ano, token);
            if (response.statusRetorno === 401){
                handleLogout();
                navigate('/');
            }
            if (response?.data?.length) {
                const anuidadeData = response.data[0];
                setAnuidade(anuidadeData);
                setPedido(anuidadeData.pedido?.semPedido === 0 ? anuidadeData.pedido : null);
            } else {
                Swal.fire({
                    title: 'Houve um erro ao consultar a sua anuidade!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Houve um erro ao consultar a sua anuidade!',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
            handleLogout();
            navigate('/');
        }
    };

    useEffect(() => {
        listarMinhaAcademia();
        listarAnuidadeVigente();
    }, []);

    useEffect(() => {
        if (pedido?.status === 0 && !intervalStarted) {
            setIntervalStarted(true);
            const intervalId = setInterval(() => {
                listarAnuidadeVigente();
            }, 10000);

            return () => {
                clearInterval(intervalId);
                setIntervalStarted(false);
            };
        }
    }, [pedido]);

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <strong>Anuidade {ano}</strong>
                </div>
            </div>
            <div className="row">
                {anuidade ? (
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <h5>
                                    {user ? (
                                        <p>
                                            Olá {user.name}, a sua anuidade de {ano} está{' '}
                                            {anuidade.pedido.status === 1 
                                                ? 'em dia e agora você pode participar dos eventos!' 
                                                : 'pendente e você ainda não pode participar dos eventos!'}
                                        </p>
                                    ) : (
                                        <p>Carregando informações do usuário...</p>
                                    )}
                                </h5>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td>Ano Vigente</td>
                                            <td>{anuidade.ano_vigente}</td>
                                        </tr>
                                        <tr>
                                            <td>Valor</td>
                                            <td><ValorMonetario valor={anuidade.valor} /></td>
                                        </tr>
                                        <tr>
                                            <td>Data Vencimento</td>
                                            <td><FormatDataIsoToBr dataISO={anuidade.data_vencimento} /></td>
                                        </tr>
                                        <tr>
                                            <td>Situação</td>
                                            <td>
                                                {academia.status === 'Inativo' && (
                                                    <span className="text-danger">
                                                        Vínculo pendente coma FETRON, entre em contato com a sua academia para efetuar o pagamento!
                                                    </span>
                                                )}

                                                {academia.status !== 'Inativo' && !pedido && (
                                                    <button 
                                                    className="btn-main color-2"
                                                    onClick={() => handlepagamento(user.id, anuidade.id)}
                                                    disabled={isProcessing}
                                                    >
                                                    {isProcessing ? 'Gerando Boleto...' : 'Efetuar Pagamento'}
                                                    </button>
                                                )}

                                                {pedido && pedido.status === 1 && (
                                                    <span className="text-success">Paga</span>
                                                )}

                                                {pedido && pedido.status !== 1 && (
                                                    <span className="text-warning">Pagamento Pendente</span>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {(pedido && pedido.status !== 1) && <FormaPagamento pedido={pedido} />} 
                    </>
                ) : (
                    <p>Nenhuma anuidade encontrada para {ano}.</p>
                )}
            </div>
        </>
    );
}
